export default {
  containers: {
    location_info: 'Informações da Localização',
    attributes: 'Atributos',
    links: 'Ligações',
  },
  labels: {
    title: 'Título',
    phone_number: 'Número de Telefone',
    description: 'Descrição',
    website: 'Website',
    address: 'Morada',
    regular_hours: 'Horário Regular',
    page_urls: 'URLs da Página',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    sunday: 'Domingo',
    twenty_four_hours: '24h',
    open_24_hours: 'Aberto 24 Horas',
    open_time: 'Hora de Abertura',
    close_time: 'Hora de Fecho',
    url: 'URL',
    provider_type: 'Tipo de Fornecedor',
    provider_types: {
      merchant: 'Comerciante',
      aggregator: 'Agregador',
    },
    place_action_type: 'Tipo',
    is_preferred: 'Preferido',
    place_action_types: {
      appointment: 'Marcação de consulta',
      online_appointment: 'Marcação de consulta online',
      dining_reservation: 'Link de reservas',
      food_ordering: 'Encomenda de comida para entrega e/ou take-away',
      food_delivery: 'Link de entrega',
      food_takeout: 'Link de take-away',
      shop_online: 'Compras, com entrega e/ou levantamento',
    },
    no_links: 'Sem links disponíveis para este negócio',
    url_menu: 'Link do menu',
    url_reservations: 'Link de reservas',
  },
  placeholders: {
    title: 'Título',
    phone_number: 'Número de Telefone',
    description: 'Descrição',
    website: 'Website',
    address: 'Morada',
    regular_hours: 'Horário Regular',
    page_urls: 'URLs da Página',
    address_line_1: 'Morada (linha 1)',
    postal_code: 'Código Postal',
    locality: 'Localidade',
    region_code: 'Código de Região',
    language_code: 'Código de Idioma',
    select_time: 'Selecionar Hora',
    url: 'URL',
  },
  buttons: {
    submit: 'Submeter',
    add: 'Adicionar',
    delete: 'Eliminar',
    generate_description: 'Gerar Descrição com IA',
  },
  validation: {
    required: 'Este campo é obrigatório',
    invalid_url: 'URL inválido',
  },
  toasts: {
    success: 'Alterações guardadas!',
    description_generation_failed: 'Não foi possível gerar uma descrição. Tente novamente.',
  },
};
